import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IUserRepository } from '../../repositories/interfaces/iUserRepository';
import { IForgotPasswordVerifyPinEntity } from '../../../entity';

export interface IForgotPasswordVerifyPinByMsisdnUseCase {
    execute(otp: string, verificationGuid: string): Promise<IForgotPasswordVerifyPinEntity>;
}

export class ForgotPasswordVerifyPinByMsisdnUseCase implements IForgotPasswordVerifyPinByMsisdnUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get userRepo(): IUserRepository {
        return container.resolve<IUserRepository>(DI.REPOSITORIES.IUserRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(otp: string, verificationGuid: string): Promise<IForgotPasswordVerifyPinEntity> {
        return await this.userRepo.forgotPasswordVerifyPinByMsisdn(otp, verificationGuid);
    }
}
